// src/components/UI/UserAvatar/utils/frameUtils.js
import { FRAME_CLASSES } from '../constants/avatarConstants';

/**
 * Определяет тип рамки аватара на основе данных пользователя.
 * ПРИОРИТЕТ: Админ > Модератор > Библиотекарь > Донор > Легенда (рейтинг)
 */
export const getFrameType = (user, frameType = null) => {
  if (frameType) return frameType;
  if (!user) return null;

  // 1. АДМИНИСТРАТОР (Наивысший приоритет)
  if (user.is_superuser) return 'superuser';

  // 2. МОДЕРАТОР
  if (user.is_staff) return 'moderator';

  // 3. БИБЛИОТЕКАРЬ
  if (user.is_librarian) return 'librarian';

  // 4. ДОНОР
  if (user.is_donor) return 'donor';

  // 5. ЛЕГЕНДА (По рейтингу или историческому ID)
  if (user.id <= 30 || (user.rating && user.rating >= 1000)) {
    return 'legend';
  }

  return null;
};

/**
 * Возвращает CSS класс для рамки
 */
export const getFrameClass = (withFrame, frameType, user) => {
  if (!withFrame) return '';
  const type = getFrameType(user, frameType);
  return type ? FRAME_CLASSES[type] : '';
};
